/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{box-sizing:border-box;display:block;position:absolute;width:100%;height:100%;min-width:1400px}"];
export { styles as styles };
